import UploadWidget from "./UploadWidget";

export default UploadWidget;
